import React from 'react';
import { appStoreLink } from 'utils/useGotoAppInstall';
import { AppStore } from 'components/Icons/Stores';

export default props => {
    return <a href={appStoreLink('https')} title='Apple Store' {...props}><AppStore /></a>
}